<template>
  <el-form-item style="width:220px;height:150px" prop="name">
    <span class="img-remove" v-if="imgurl" @click="removeImg">
      x
    </span>
    <el-upload
      class="uploader"
      :auto-upload="false"
      :show-file-list="false"
      :multiple="false"
      action=""
      :on-change="uploadImg"
    >
      <div style="width:220px;height:150px" v-if="imgurl" @click.stop="showBig">
        <img
          :src="imgurl"
          :class="imgTitle == 'yyzz' ? 'yyzz' : ''"
          class="avatar"
          alt=""
        />
      </div>
      <div v-else class="div-img-icon">
        <i class="el-icon-upload avatar-uploader-icon"></i>
        <div class="el-upload-text">
          <slot name="centerName"></slot>
        </div>
      </div>
    </el-upload>
    <!-- :class="imgTitle == 'yyzz' ? 'bigimg-father-yyzz' : 'bigimg-father'" -->
    <div class="bigimg-father" v-if="bigimg">
      <span class="bigimg-remove" v-if="bigimg">
        <i
          class="el-icon-refresh"
          style="color:#7b7b7b"
          @click="revolveBig"
        ></i>
        <i @click="removeBig">✗</i>
      </span>
      <!-- :style="imgTitle == 'yyzz'? 'width:450px;height:660px': 'width:660px;height:450px'" -->
      <img
        style="width:660px;height:450px"
        :style="'transform:rotate(' + revolve + 'deg)'"
        :src="bigimg"
        alt=""
      />
    </div>
  </el-form-item>
</template>
<script>
import { submitDiscernLicense } from "../api/common.js";

export default {
  name: "uploadImg",
  // inject:["mask"],
  data() {
    return {
      imgurl: "",
      info: {},
      imgstr: "",
      bigimg: "",
      access_token: localStorage.getItem("token"),
      revolve: 0
    };
  },
  props: {
    imgTitle: String,
    imgsrc: String,
    removeS: Boolean
  },
  watch: {
    imgsrc(item1, item2) {
      this.imgurl = item1;
    }
  },
  mounted() {
    // console.log(this.u)
  },
  methods: {
    showBig() {
      this.bigimg = this.imgurl;
      // this.mask();
    },
    removeImg() {
      this.revolve = 0;
      this.imgurl = "";
      this.$emit("removeImg", this.imgTitle);
    },
    removeBig() {
      this.bigimg = "";
    },
    async uploader(file) {
      var that = this;
      var reader = new FileReader();

      this.info = {};
      var obj = {
        access_token: localStorage.getItem("access_token")
      };
      reader.readAsDataURL(file.raw);
      reader.onload = async function() {
        that.imgurl = reader.result;
        const blob1 = new Blob([file.raw], {
          type: "image/jpeg"
        });
        switch (that.imgTitle) {
          case "yyzz":
            that.successMessage("正在获取信息，请稍等");
            try {
              var { data: res } = await that.$http.post(
                that.$url + "common/DiscernLicense",
                {
                  access_token: obj.access_token,
                  base64: that.imgurl
                },
                {
                  headers: {
                    "content-type": "application/json"
                  }
                }
              );
              if (res) {
                this.info = res;
              }
            } catch (e) {
              that.warnMessage("图片识别失败，请手工填写相应内容", e);
            }
            break;
          case "zm":
          case "beneficiary_zm":
            try {
              var { data: res } = await that.$http.post(
                that.$url + "common/DiscernFrontID",
                {
                  access_token: that.access_token,
                  base64: that.imgurl
                },
                {
                  headers: {
                    "content-type": "application/json"
                  }
                }
              );
              if (res) {
                this.info = res;
              }
            } catch (e) {
              that.warnMessage("图片识别失败，请手工填写相应内容", e);
            }

            break;
          case "fm":
          case "beneficiary_fm":
            try {
              var { data: res } = await that.$http.post(
                that.$url + "common/DiscernBackID",
                {
                  access_token: that.access_token,
                  base64: that.imgurl
                },
                {
                  headers: {
                    "content-type": "application/json"
                  }
                }
              );
              if (res) {
                this.info = res;
              }
            } catch (e) {
              that.warnMessage("图片识别失败，请手工填写相应内容", e);
            }
            break;
          case "bank":
            try {
              var { data: res } = await that.$http.post(
                that.$url + "common/DiscernBankCard",
                {
                  access_token: that.access_token,
                  base64: that.imgurl
                },
                {
                  headers: {
                    "content-type": "application/json"
                  }
                }
              );
              if (res) {
                this.info = res;
              }
            } catch (e) {
              that.warnMessage("图片识别失败，请手工填写相应内容", e);
            }
            break;
        }
        var { data: res } = await that.$http.post(
          that.$url + "service/uploadimg",
          blob1,
          {
            headers: { Authorization: JSON.stringify(obj) }
          }
        );
        if (
          res.return_code == "FAIL" ||
          !res.resp_data ||
          res.return_msg == "文件不能大于2M，请重新上传"
        ) {
          that.warnMessage(res.return_msg);
          that.imgurl = "";
          return;
        }
        if (res.resp_data.media_no) {
          that.imgstr = res.resp_data.media_no;
        } else {
          that.warnMessage("上传照片失败，请重试!!!");
        }
        var Object = {
          title: that.imgTitle,
          img: that.imgstr,
          img_info: this.info
        };
        that.$emit("getReturn", Object);
        // this.disabled=true;
      };
    },
    uploadImg(file) {
      var that = this;
      var reader = new FileReader();

      reader.readAsDataURL(file.raw);
      reader.onload = async function() {
        that.imgurl = reader.result;
        if (that.imgTitle == "yyzz") {
          try {
            const base64img = that.imgurl.split(",");
            const res = await submitDiscernLicense(base64img[1]);
            // console.log("上传营业执照",res);
            if (that.testR(res)) {
              that.$emit("getReturn", res.data.resp_data);
            }
          } catch (e) {
            that.warnMessage(JSON.stringify(e));
          }
        }
      };
    },
    revolveBig() {
      this.revolve += 90;
      if (this.revolve >= 360) {
        this.revolve = 0;
      }
    }
  },
  mounted() {
    /* if (false) {
      this.imgurl = "";
    } */
  }
};
</script>
<style scoped>
.bigimg-father {
  width: auto;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}
.bigimg-father-yyzz {
  width: auto;
  height: auto;
  position: fixed;
  top: 30px;
  z-index: 100;
}
.img-remove {
  height: 20px;
  width: 20px;
  position: absolute;
  right: 20px;
  background-color: rgb(199, 49, 49);
  line-height: 1.4;
  text-align: center;
  color: #fff;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 5px;
  margin: 0 -20px 0 0;
  z-index: 10;
  cursor: pointer;
}
.bigimg-remove {
  height: 60px;
  width: 120px;
  position: fixed;
  right: -100px;
  font-size: 60px;
  color: rgb(199, 49, 49);
  text-align: center;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 5px;
  margin: 0 -20px 0 0;
  z-index: 1-1;
  cursor: pointer;
}
.el-upload-text {
  color: rgb(99, 99, 99);
}
.avatar {
  width: 220px;
  height: 150px;
  border-radius: 6px;
  /* margin-top: -5px; */
}
.uploader {
  border: 1px dashed #97979770;
  width: 220px;
  height: 150px;
  text-align: center;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-img-icon {
  /* margin-top: 40px; */
  width: 220px;
  height: 150px;
}
.div-img-icon >>> i {
  color: rgba(0, 255, 255, 0);
}
.yyzz {
  width: 150px;
  height: 220px;
  transform: rotate(-90deg);
  margin-top: -35px;
}
i {
  font-style: normal;
}
/* @keyframes revolve {
  from {
    transform:rotate(90deg) ;
  }
  to {
    
  }
} */
</style>
